import React from 'react';
import { Modal, Form, Button, Alert } from 'antd';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../../../variables/api/axiosInstance';
import ParamMotifSelect from '../../../../components/ParamMotifSelect';

export default function AnnulerPrefinancementModal({ prefinancement, onClose, onSuccess }) {
    const { t } = useTranslation('dossierFinance');
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = React.useState(false);
    if (!prefinancement) return null;

    const isValide = prefinancement.statut === 'VALIDE';

    const submit = async (vals) => {
        setSubmitting(true);
        try {
            await axiosInstance.post(`/v1/prefinancements/${prefinancement.prefinancementTrackingId}/annuler`, {
                motifAnnulation: vals.motifAnnulation,
            });
            toast.success(t('prefinancements.annuler.succes'));
            form.resetFields();
            onSuccess?.();
        } catch (e) {
            toast.error(e.response?.data?.message || t('prefinancements.annuler.erreur'));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal title={t('prefinancements.annuler.titre')}
            open={!!prefinancement} onCancel={onClose} footer={null} destroyOnClose>
            {isValide && (
                <Alert type="warning" showIcon style={{ marginBottom: 16 }}
                    message={t('prefinancements.annuler.alerteTitre')}
                    description={t('prefinancements.annuler.alerteTexte')} />
            )}
            <Form form={form} layout="vertical" onFinish={submit}>
                <Form.Item name="motifAnnulation" label={t('prefinancements.annuler.motif')}
                    rules={[{ required: true, message: t('prefinancements.annuler.motifObligatoire') },
                            { max: 500, message: t('prefinancements.annuler.motifMax') }]}>
                    <ParamMotifSelect
                        type="ANNULATION"
                        placeholder={t('prefinancements.annuler.motifPlaceholder')}
                    />
                </Form.Item>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <Button onClick={onClose}>{t('prefinancements.annuler.retour')}</Button>
                    <Button danger type="primary" htmlType="submit" loading={submitting}>
                        {t('prefinancements.annuler.confirmer')}
                    </Button>
                </div>
            </Form>
        </Modal>
    );
}
